import {
  CLEAR_RFI_STORE,
  RFI_CMS_VALUE,
  RFI_LIST,
  SET_JUMIO_AVAILABILITY,
  SET_RFI_SG_KYC_DATA,
  SET_RFI_SG_KYC_SCREEN,
  SET_SELECTED_ADDRESS_DOCUMENT,
  SET_SELECTED_FLOW_TYPE,
  SET_TEMP_RFI_FORM_VALUES,
  TOGGLE_IS_RFI_BANNER_VISIBLE,
  TOGGLE_LOAD_PERSONAL_DATA,
  TRANSACTION_KYC_VALUE
} from '../../action-contants';

import { handleError } from '../common-message/message-action';
import { API_URL } from '../../../utils/config';
import { makeApiCall } from '../common/common-action';

// Sort function that puts KYC_TYPE entries first
export const sortByKYCType = (data) => {
  return data.sort((a, b) => {
    if (a.document_code === 'KYC_TYPE' && b.document_code !== 'KYC_TYPE') {
      return -1; // a comes before b
    } else if (a.document_code !== 'KYC_TYPE' && b.document_code === 'KYC_TYPE') {
      return 1; // b comes before a
    } else {
      return 0; // keep original order for items with same status
    }
  });
};

export function getRfi() {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/rfi`,
        withCredentials: true
      });
      if (response) {
        const sortedRfiList = sortByKYCType(response.data?.data || []);
        return {
          data: sortedRfiList,
          success: response.data.success
        };
      }
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
  else byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

export const getEKYCRedirectUrl = (data, isJumioEkycRfi) => {
  return async (dispatch) => {
    try {
      const payload = new FormData();
      payload.append('rfi_response', JSON.stringify(data));
      if (isJumioEkycRfi) {
        payload.append('jumio_version', 'v2');
      }
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/rfi`,
        withCredentials: true,
        data: payload
      });
    } catch (error) {
      dispatch(handleError(error));
      throw error.response;
    }
  };
};

export function submitRfiRequest(
  props,
  { documents, files, fieldProps, additionalDocs },
  sectionPrependString,
  radioQuestionField = null
) {
  return async (dispatch) => {
    try {
      const payload = new FormData();
      additionalDocs &&
        additionalDocs.forEach((obj) => {
          if (obj && obj.additional_docs && obj.additional_docs.name) {
            payload.append('additional_docs', obj.additional_docs, obj.additional_docs.name);
          } else if (obj && obj.additional_docs && !obj.additional_docs.name) {
            payload.append(
              'additional_docs',
              dataURItoBlob(obj.additional_docs),
              `additional_docs${obj.extension}`
            );
          }
        });

      Object.keys(files).forEach((fileName) => {
        let extension = files[fileName].name
          ? files[fileName].name
          : `${fileName}.${files[fileName].type.split('/')[1]}`;
        payload.append(fileName, files[fileName], extension);
      });
      let rfi_response = {},
        docNameArr,
        rfiIdArr = [];
      let globalRFIId = null;
      documents.forEach((key) => {
        docNameArr = key.type.split('.');
        let rfi_id = docNameArr[0].replace(sectionPrependString, '');
        globalRFIId = rfi_id;
        rfiIdArr.push(rfi_id);
        delete key.type;
        rfi_response[rfi_id] = key;
      });
      fieldProps.forEach((key) => {
        docNameArr = key.split('.');
        let rfi_id = docNameArr[0].replace(sectionPrependString, '');
        globalRFIId = rfi_id;
        if (!rfiIdArr.includes(rfi_id)) {
          if (!rfi_response[rfi_id]) {
            rfi_response[rfi_id] = {};
            rfi_response[rfi_id][docNameArr[2]] =
              props[docNameArr[0]][docNameArr[1]][docNameArr[2]];
          } else {
            rfi_response[rfi_id][docNameArr[2]] =
              props[docNameArr[0]][docNameArr[1]][docNameArr[2]];
          }
        }
      });

      /* For Nested field processing as per api contract */
      const nested_field = radioQuestionField;
      if (nested_field) {
        if (
          Object.prototype.hasOwnProperty.call(
            rfi_response[globalRFIId].details || {},
            nested_field
          )
        ) {
          rfi_response[globalRFIId][nested_field] = rfi_response[globalRFIId].details[nested_field];
          delete rfi_response[globalRFIId].details[nested_field];
        }
        if (rfi_response[globalRFIId][nested_field]) {
          const {
            identity_number,
            date_of_expiry,
            date_of_issue,
            details = {}
          } = rfi_response[globalRFIId];
          const nestedDetails = {
            ...details,
            ...(identity_number != null ? { identity_number } : {}),
            ...(date_of_expiry != null ? { date_of_expiry } : {}),
            ...(date_of_issue != null ? { date_of_issue } : {})
          };
          rfi_response[globalRFIId].nested_fields_data = {
            [nested_field]: {
              fieldname: rfi_response[globalRFIId].fieldname,
              details: nestedDetails
            }
          };
          delete rfi_response[globalRFIId].details;
          delete rfi_response[globalRFIId].fieldname;
          delete rfi_response[globalRFIId].identity_number;
          delete rfi_response[globalRFIId].date_of_expiry;
          delete rfi_response[globalRFIId].date_of_issue;
        }
      }

      payload.append('rfi_response', JSON.stringify(rfi_response));
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/rfi`,
        withCredentials: true,
        data: payload
      });
    } catch (error) {
      dispatch(handleError(error));
      throw error.response;
    }
  };
}

export function submitAdditionalInfoRfi(rfiResponse) {
  return async (dispatch) => {
    try {
      const payload = new FormData();
      payload.append('rfi_response', JSON.stringify(rfiResponse));
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/rfi`,
        withCredentials: true,
        data: payload
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function setKycTrancData(data) {
  return {
    type: TRANSACTION_KYC_VALUE,
    data
  };
}
export function setRfiCmsData(data) {
  return {
    type: RFI_CMS_VALUE,
    data
  };
}

export const toggleIsRFIBannerVisible = (data) => ({
  type: TOGGLE_IS_RFI_BANNER_VISIBLE,
  data
});

export function setRfiList(data) {
  return {
    type: RFI_LIST,
    data
  };
}
export const findNearestDateEntry = (data, dateProperty) => {
  return data?.reduce((nearest, entry) => {
    const dateValue = entry?.[dateProperty];
    if (dateValue === null) return nearest;
    if (!nearest || new Date(dateValue) < new Date(nearest?.[dateProperty])) {
      return entry;
    }
    return nearest;
  }, null);
};

export const getMonthDifference = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const yearsDifference = end.getFullYear() - start.getFullYear();
  const monthsDifference = end.getMonth() - start.getMonth();
  return yearsDifference * 12 + monthsDifference;
};

export const isExpiryDateHalfCompleted = (startDate, expiryDate) => {
  const start = new Date(startDate);
  const expiry = new Date(expiryDate);
  const today = new Date();
  // Total duration in milliseconds
  const totalDuration = expiry - start;
  const halfwayPoint = totalDuration / 2;
  const halfwayDate = new Date(start.getTime() + halfwayPoint);
  // Check if today's date is past the halfway point
  return today > halfwayDate;
};

export const fetchData = (baseUrl, url, params = {}) => {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        url: `${baseUrl}${url}`,
        withCredentials: true,
        method: 'get',
        params
      });
      return response?.data?.data;
    } catch (err) {
      dispatch(handleError(err));
      return err;
    }
  };
};

export const submitRfiData = (payload) => {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/rfi`,
        withCredentials: true,
        data: payload
      });
      return response?.data;
    } catch (err) {
      dispatch(handleError(err));
    }
  };
};

export const changeRfiSgKYCScreen = (data) => {
  return {
    type: SET_RFI_SG_KYC_SCREEN,
    data
  };
};

export const storeRfiSGKYCData = (data) => {
  return {
    type: SET_RFI_SG_KYC_DATA,
    data
  };
};

export const toggleLoadPersonalDataSingpass = (data) => {
  return {
    type: TOGGLE_LOAD_PERSONAL_DATA,
    data
  };
};

export const setFlowType = (data) => {
  return {
    type: SET_SELECTED_FLOW_TYPE,
    data
  };
};

export const setTempRfiFormValues = (data) => {
  return {
    type: SET_TEMP_RFI_FORM_VALUES,
    data
  };
};

export const setJumioAvailability = (data) => {
  return {
    type: SET_JUMIO_AVAILABILITY,
    data
  };
};

export const clearRfiStore = () => {
  return {
    type: CLEAR_RFI_STORE
  };
};

export const setSelectedAddressDoc = (data) => {
  return {
    type: SET_SELECTED_ADDRESS_DOCUMENT,
    data
  };
};
